import { pxToRem } from '../../utils';
export default (function (siteVars) {
    return {
        backgroundColor: siteVars.white,
        borderColor: siteVars.gray06,
        padding: pxToRem(10) + " " + pxToRem(14),
    };
});
